import React from "react";

const resetZoomIcon = (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.6088 14.2535L21.7196 19.3644C21.8992 19.5442 22.0001 19.788 22 20.0421C21.9999 20.2962 21.8989 20.5399 21.7191 20.7196C21.5393 20.8992 21.2956 21.0001 21.0415 21C20.7873 20.9999 20.5436 20.8989 20.364 20.7191L15.2532 15.6082C13.7254 16.7916 11.8042 17.3485 9.88041 17.1656C7.9566 16.9827 6.17473 16.0737 4.89728 14.6237C3.61982 13.1736 2.94275 11.2913 3.0038 9.35977C3.06484 7.42821 3.85942 5.59245 5.22589 4.22594C6.59236 2.85944 8.42807 2.06484 10.3596 2.0038C12.2911 1.94275 14.1733 2.61984 15.6233 3.89732C17.0734 5.17481 17.9823 6.95673 18.1652 8.88058C18.3481 10.8044 17.7912 12.7257 16.6079 14.2535H16.6088ZM10.6004 15.2995C12.112 15.2995 13.5618 14.6989 14.6307 13.63C15.6996 12.5611 16.3001 11.1113 16.3001 9.59959C16.3001 8.08789 15.6996 6.63811 14.6307 5.56917C13.5618 4.50024 12.112 3.89972 10.6004 3.89972C9.08869 3.89972 7.63894 4.50024 6.57003 5.56917C5.50112 6.63811 4.90062 8.08789 4.90062 9.59959C4.90062 11.1113 5.50112 12.5611 6.57003 13.63C7.63894 14.6989 9.08869 15.2995 10.6004 15.2995ZM7.75049 10.5496C7.49854 10.5496 7.25692 10.4495 7.07877 10.2713C6.90061 10.0932 6.80053 9.85154 6.80053 9.59959C6.80053 9.34764 6.90061 9.10601 7.07877 8.92786C7.25692 8.7497 7.49854 8.64961 7.75049 8.64961H13.4502C13.7022 8.64961 13.9438 8.7497 14.1219 8.92786C14.3001 9.10601 14.4002 9.34764 14.4002 9.59959C14.4002 9.85154 14.3001 10.0932 14.1219 10.2713C13.9438 10.4495 13.7022 10.5496 13.4502 10.5496H7.75049Z"
			fill="#D1D1D9"
		/>
	</svg>
);

export default resetZoomIcon;
